<template>
    <div>
      <!-- :desc="'Güncelleme'+kariyeri.update" -->
     <navbar :title="fad" :box="box"/>
      <van-card
       currency=""
        :price="kariyeri.puan+' KP'"
        :desc="'Kariyeriniz: '+kariyeri.ad"
        :thumb="'https://ayurlifeworld.com/kariyer/'+kariyeri.foto"
      />
<van-swipe>
  <van-swipe-item v-for="(image, index) in imagesler" :key="index">
    <van-image
  width="10rem"
  height="7rem"
  fit="contain"
  :src="'https://ayurlifeworld.com/upload/'+image"
/>
  </van-swipe-item>
</van-swipe>
      <van-divider>Duyurular</van-divider>
<van-panel v-for="(items,index) in makaleler" :key="index"  :title="items.ad" :status="items.kategori">
  <div>{{items.icerik}}</div>
</van-panel>      
    <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import navbar from './nav';
import {Toast} from 'vant';
import {Dialog} from 'vant';
export default {
components:{
  navbar
},
  data() {
    return {
      makaleler:[],
      imagesler: [],
      posts:[],
      show:false,
      kariyeri:{
        puan:0,
        ad:'',
        foto:'',
        update:''
      },
      fad:'Ayurlife World', // local db ye geçince local storage den gelecek,
      kod:helper.settings.ayar().uye,
      obje:[],
      obje2:[],
      derinlik:0,
      anakol:0,
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0,

    };
  },
  computed: {
    groups(){ 
      this.altSayac = this.grupla(this.obje).length
      return this.grupla(this.obje) 
      },
  },
  created (){
    this.show = true
    userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
    .then(res => {   
      helper.request.get("kariyer/"+this.kod)
       .then(res => {
         if (res.results.length === 0){ this.hobbala(
           [{puan:0,uye_kod:this.kod}]
           )}
           else{this.hobbala(res.results,0)}
         //}
         })
      }
    )
    .catch(err => {userService.logout()})
  },
  methods : {


     hobbala(arg,anakol){
      var pross = 0
      for (let i = 0, p = Promise.resolve(); i < arg.length; i++) {
        p = p.then(_ => new Promise(resolve => {
          //setTimeout(() => {
          anakol++
          this.derinlik = 1
          let data = {
          kod:arg[i].uye_kod,
          derinlik : this.derinlik,
          anakol:anakol,
          qv:arg[i].puan
          }
          this.obje.push(data)
           this.kol(data.kod,data.derinlik,anakol)
            .then(res => {
              pross++
              if(arg.length === pross){
                setTimeout(() => {

                this.grupla(this.obje)
                  .then(res=> {
                    console.log(res)
                   this.kariyer(res)
                      .then(res=>{
                        this.kariyeri.puan = res.puan
                        let data = {
                          id:res.id,
                          uye_kod:this.kod
                        }
                        this.kariyer_update(data)
                      })
                  })}, 2000);
              }
              resolve()
            })
           }
        ))
      }
    },
    kol(kod,derinlik,anakol,ay,yil){
      return new Promise ((resolve,reject)=>{
        helper.request.get("kariyer/"+kod)
        .then(res => {
          if (res.results.length===0){resolve(true)}
           else{
             derinlik++
              this.getProduct(res.results,derinlik,anakol)
               .then(res=>{
                 this.getProduct2().then(response => {
                   //setTimeout(() => {
                     resolve()
                   //},1000 );
                   
                 })
             })
            }
        })
      })
    },
    getProduct2(){
      return new Promise ((resolve,reject)=>{
        var pros = 0
        this.obje2.forEach((element) => { 
            this.kol(element.kod,element.derinlik,element.anakol)
            pros++
        });
        if (pros === this.obje2.length) resolve()
      })
    },
    getProduct(arg,derinlik,anakol){ // sabit arttıcı
    return new Promise ((resolve,reject)=>{
    this.obje2 = []
      var pros = 0
          arg.forEach((element,i) => {
              let data = {
                 kod:element.uye_kod,
                 derinlik : derinlik,
                 anakol:anakol,
                 qv:element.puan,
               }
          this.obje.push(data)
          this.obje2.push(data)
          pros++
          });

        //  },500);
          if(arg.length === pros){
            resolve(true)
          }
      })
    },
    grupla(arr,param1,param2){
      return new Promise ((resolve,reject) => {
          var result = [] 
          arr.forEach(function (a) {
            if ( !this[a.anakol] ) {
              this[a.anakol] = { anakol: a.anakol,qv:0};
                result.push(this[a.anakol]);
            }
            this[a.anakol].qv +=a.qv;
          }, Object.create(null));
          resolve(result)
        }) 
    },
    kariyer_kol_kontrol(obj){
      return new Promise((resolve,reject) => {
        helper.request.get('kariyer_kendi/'+this.kod)
        .then(res => {
        let pross = 0
        let toplamkol = obj.length
        let toplampuan = 0
        toplampuan=toplampuan+res.puan
        let dort_k3 = 0 // 600000
        let dort_k2 = 0 // 180000
        let dort_k1 = 0 // 40000
        let uc_k1 = 0 // 16000
        let iki_k2 = 0 // 8000
        let iki_k1 = 0 // 4000
        obj.forEach(arg => {
          toplampuan += arg.qv
            if (arg.qv>=4000) iki_k1++
            if (arg.qv>=8000)   iki_k2++
            if (arg.qv>=16000)  uc_k1++
            if (arg.qv>=40000)  dort_k1++
            if (arg.qv>=180000) dort_k2++
            if (arg.qv>=600000) dort_k3++
            // if (arg.qv>=4000 && arg.qv<8000) iki_k1++
            // if (arg.qv>=8000 && arg.qv<16000)   iki_k2++
            // if (arg.qv>=16000 && arg.qv<40000)  uc_k1++
            // if (arg.qv>=40000 && arg.qv<180000 )  dort_k1++
            // if (arg.qv>=180000 && arg.qv<600000) dort_k2++
            // if (arg.qv>=600000) dort_k3++
          pross++
        });

        if(pross = toplamkol){
            if(dort_k3 >= 4) {resolve({id:12,puan:toplampuan})} //dört_k3
              else if(dort_k2 >= 4) {resolve({id:11,puan:toplampuan})} // dört_k2
                else if(dort_k1 >= 4) {resolve({id:10,puan:toplampuan})}//dört k1
                  else if(uc_k1 >= 3) {resolve({id:9,puan:toplampuan})}// üç_k1
                    else if(iki_k2 >= 2) {resolve({id:8,puan:toplampuan})}// iki_k2
                      else if(iki_k1 >= 2) {resolve({id:7,puan:toplampuan})}// iki_k1
            else{
                if (toplampuan>4000){resolve({id:6,puan:toplampuan})}
                if (toplampuan>=2000 && toplampuan<4000){resolve({id:5,puan:toplampuan})}
                if (toplampuan>=700 && toplampuan<2000){resolve({id:4,puan:toplampuan})}
                if (toplampuan>=400 && toplampuan<700){resolve({id:3,puan:toplampuan})}
                if (toplampuan>=200 && toplampuan<400){resolve({id:2,puan:toplampuan})}
                if (toplampuan>=0 && toplampuan<200){resolve({id:1,puan:toplampuan})}
            }
        }
      })
      .catch(err => {reject(err)})
      })
   },

    kariyer(obj){
      return new Promise((resolve) => {
          this.kariyer_kol_kontrol(obj)
          .then(res => {
            resolve(res)
          })
      })
    },
    kariyer_update(data){
      helper.request.post('update_kariyer',data)
        .then(res=>{
         this.kariyergetir();
        })
       .catch(err=>{
       Toast("Kariyer Hesaplanamadı")
       this.show = false
      })
    },
    kariyergetir(){
        helper.request.get('kariyer_getir/'+this.kod)
        .then(res =>{
          this.kariyeri.ad = res.ad
          this.kariyeri.foto = res.foto
          this.kariyeri.update = res.logu
          this.slider()
          //this.makale()
          this.show = false
        })
    },

    slider(){
      helper.request.get('slider')
      .then(res=>{
        res.results.forEach(element => {
            this.imagesler.push(element.foto)
        });
      })
    }, 
    makales(){
      helper.request.get('makale/')
      .then(res=>{
        this.makaleler = res.results
      })
    }      
  }
};
</script>
<style>
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
</style>


// WEBPACK FOOTER //
// src/components/main.vue